import { Badge } from 'primereact/badge';
import { Tooltip } from 'primereact/tooltip';
import React, { useState } from 'react';

import { IconData } from '../../../components/layout/leftDrawerEmojis/type';
import UsersMood from '../usersMood/UsersMood';
import './Emoticon.css';

export type EmoticonProps = {
    data: IconData;
    empId: string;
    managerdisplay: string;
    onClickEmoticon: (iconName: string, id: string | undefined) => void;
    isActive?: boolean;
    indexIcon: number;
};

const Emoticon = ({
    data: icon,
    empId,
    managerdisplay,
    onClickEmoticon,
    isActive = false,
    indexIcon,
}: EmoticonProps) => {
    const [moodType, setMoodType] = useState<string | undefined>(undefined);

    const handleOnShow = () => {
        setMoodType(icon?.name);
    };

    return (
        <>
            <button
                className={
                    isActive
                        ? `badge-container emoji-btn-active ${icon?.name?.toLowerCase()}`
                        : `badge-container emoji-btn ${icon?.name?.toLowerCase()}`
                }
                aria-label={icon?.label}
                onClick={() => onClickEmoticon(icon?.name, icon?.id)}
            >
                {icon?.iconElement}
                <Badge
                    value={icon?.badgeContent}
                    className={indexIcon % 2 === 0 ? 'p-badge p-badgeleft' : 'p-badge p-badgeright'}
                />
            </button>
            <Tooltip
                target={`.${icon?.name?.toLowerCase()}`}
                className="icon-tooltip"
                position="right"
                showDelay={500}
                onShow={handleOnShow}
            >
                <div className="moodTitle">{icon.label}</div>
                <UsersMood empId={empId} moodType={moodType} managerdisplay={managerdisplay} />
            </Tooltip>
        </>
    );
};

export default Emoticon;
